import { LoadableAfterPaint } from '@confluence/loadable';

export const ShortcutsSection = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ShortcutsSection" */ '../src/ShortcutsSection'))
			.ShortcutsSection,
});
